<!-- BEGIN #app -->
<div id="app" class="app app-sidebar-collapsed" [class.watch-fullscreen]="isWatchView">
  <app-public-header *ngIf="!isWatchView"></app-public-header>
  <!--<app-navigation [collapse]="app.sideBarCollapsed" [isNavigationOpen]="isNavigationOpen" [isPublic]="true"></app-navigation>-->
  
  <!-- BEGIN #content -->
  <div id="content" class="app-content" [class.fullscreen]="isWatchView">
    <router-outlet></router-outlet>
  </div>
  <!-- END #content -->
</div>
<!-- END #app -->